<template>
<div class="partnerBG">
    <b-container>
        <b-row>
            <b-col cols="12" v-if="!isMobile()">

                <section data-v-77e2c447="" data-v-a589c2a8="" id="anchor-partners" class="partners">
                <div data-v-77e2c447="" class="partners__title">
                    <br><br><br><br><br>
                    <h2 class="headingPartner">Strategic Partners</h2>
                </div>


                <ul data-v-77e2c447="" class="press-logos main-partners homePartners" >
                    <li data-v-77e2c447="" class="press-logos-item__big homePartner" v-for="id in options" :key="id">
                        <a data-v-77e2c447="" rel="noreferrer" :href="id.website" target="_blank">
                            <img data-v-77e2c447="" :src="id.imageOf" class="press_img1">
                        </a>
                    </li>
                </ul>
                </section>
            </b-col>

            <b-col cols="12" v-if="isMobile()">

                <section data-v-77e2c447="" data-v-a589c2a8="" id="anchor-partners" class="partners">
                <div data-v-77e2c447="" class="partners__title">
                    <br><br><br><br><br>
                    <h2 class="headingPartner">Strategic Partners</h2>
                </div>


                <ul data-v-77e2c447="" class="press-logos main-partners homePartners" >
                    <li data-v-77e2c447="" class="press-logos-item__big homePartner" v-for="id in options" :key="id">
                        <a data-v-77e2c447="" rel="noreferrer" :href="id.website" target="_blank">
                            <img data-v-77e2c447="" :src="id.imageOf" class="press_img1">
                        </a>
                    </li>
                </ul>
                </section>
            </b-col>
        </b-row>
    </b-container>
    <br><br><br><br>
</div>
</template>

<script>
import arcadeImage from '../../assets/partnerships/arcade.png'
import bossImage from '../../assets/partnerships/bossbeauties.png'
import braindomImage from '../../assets/partnerships/braindom.png'
import broskeeImage from '../../assets/partnerships/broskees.png'
import godjiraImage from '../../assets/partnerships/godjira.png'
import littlesImage from '../../assets/partnerships/littles.jpg'
import llamaverseImage from '../../assets/partnerships/llamaverse.png'
import nanopassImage from '../../assets/partnerships/nanopass.png'
import oogaImage from '../../assets/partnerships/oogaverse.png'
import sappyImage from '../../assets/partnerships/sappyseals.png'
import tsbImage from '../../assets/partnerships/TSB.svg'
import wulfzImage from '../../assets/partnerships/wulfz.png'
import zoofrenzImage from '../../assets/partnerships/ZOOFRENZ.svg'
import coniumImage from '../../assets/partnerships/conium.jpg'
import squidsImage from '../../assets/partnerships/squids.png'
import dogeImage from '../../assets/partnerships/dogepound.png'
import apeListImage from '../../assets/partnerships/apelist.jpg'
import bearxImage from '../../assets/partnerships/bearx.png'
export default {
    data: function () {
        return {
            options:[
                {name: "Arcade Land", website:"https://arcade.inc/", imageOf: arcadeImage},
                {name: "Boss Beauties", website: "https://bossbeauties.com/", imageOf: bossImage},
                {name: "Braindom", website: "https://braindomgames.com/", imageOf: braindomImage},
                {name: "Broskees", website: "https://www.broskees.io/", imageOf: broskeeImage},
                {name: "Project Godjira", website: "https://projectgodjira.io/", imageOf: godjiraImage},
                {name: "Littles", website: "https://thelittles.io/", imageOf: littlesImage},
                {name: "Llamaverse", website: "https://llamaverse.io", imageOf: llamaverseImage},
                {name: "Nanopass", website: "https://www.nanopass.io/", imageOf: nanopassImage},
                {name: "Oogaverse", website: "https://oogaverse.com/", imageOf: oogaImage},
                {name: "Sappy Seals", website: "https://www.sappyseals.io/", imageOf: sappyImage},
                {name: "Zoofrenz", website: "https://www.zoofrenz.com/", imageOf: zoofrenzImage},
                {name: "Wulfz", website: "https://wulfznft.com/", imageOf: wulfzImage},
                {name: "The Sandbox", website: "https://www.sandbox.game", imageOf: tsbImage},
                {name: "Conium", website: "https://coniun.io/", imageOf: coniumImage},
                {name: "Squids", website: "https://thesquids.io/", imageOf: squidsImage},
                {name: "Doge Pound", website: "https://thedogepoundnft.com/", imageOf: dogeImage},
                {name: "Ape List", website: "https://www.theapelist.com/", imageOf: apeListImage},
                {name: "Bear X", website: "https://bearxlabs.com/", imageOf: bearxImage},
            ]
        }
    },
    methods: {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<style scoped>
.partners .press-logos {
    display: grid;
    justify-content: center;
    align-items: center;
    grid-template-columns: repeat(6,1fr);
    grid-row-gap: 50px;
    row-gap: 50px;
    list-style-type: none;
    flex-wrap: wrap;
    padding-top: 50px;
    padding-bottom: 20px;
}

.main-partners {
    display: grid;
    grid-gap: .6vw;
    grid-template-columns: repeat(auto-fill,minmax(100px,120px));
}
.partners .press-logos .press-logos-item__big {
    margin: 0 20px;
    text-align: center;
}
a:-webkit-any-link {
    text-decoration: none;
}
.partners .press-logos .press_img1 {
    max-width: 150px;
    width: 150px;
}
.partners {
    background-color: #323232;
    color: #fff;
    z-index: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.partnerBG
{
    background: #323232;
}
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300&display=swap');
.headingPartner {
	 color: #82f5eb;
	 text-transform: uppercase;
     font-family: 'Raleway', sans-serif;
	 font-size: 8vh;
	 font-weight: 900;

}
@media (max-width: 1430px){
.partners[data-v-77e2c447] {
    padding: 90px 15%;
}
}
@media (max-width: 1120px)
{
.partners[data-v-77e2c447] {
    padding: 50px 5%;
}
}

@media (max-width: 800px){
.partners ul[data-v-77e2c447] {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 660px;
}
}

@media (max-width: 767px)
{
    .partners .press-logos[data-v-77e2c447] {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-left: 0;
    }
}




</style>


// WEBPACK FOOTER //
// src/components/Vx/Partnership.vue